import React, { useState, useRef } from "react"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Modal from "react-bootstrap/Modal"
import ModalResult from "../general/ModalResult"
import playIcon from "../../images/play-icon.svg"
import Close from "../../images/close-gray.svg"

//Styles
import { anims, colors } from "../../utils/theme"
import styled from "styled-components"

//Responsive
import { device } from "../../utils/breakpoints"

import ArrowNextIcon from "../../images/next-arrow.svg"
import ArrowPrevIcon from "../../images/prev-arrow.svg"

const ResultsSection = styled.section`
  background: #1a1a1a;
  padding: 0 0 5rem 0rem;
  & .call-to-action {
    padding: 8rem 0;
    background: #1a1a1a;
    h3 {
      color: white;
      font-weight: 800;
    }
    p {
      color: white;
      font-weight: 300;
    }
    .text-results {
      z-index: 10;
      position: relative;
      &::after {
        content: "";
        width: 2px;
        height: 160px;
        background: ${colors.sColor};
        position: absolute;
        top: 150%;
        left: 50%;
      }
    }
    & .feedback {
      display: inline-block;
      padding: 0.7em 1.6em;
      border: 2px solid ${colors.sColor};
      border-radius: 20px;
    }
    & .asesoria-button {
      padding: 0.8em 1.4em;
      background: ${colors.sColor};
      margin-bottom: 3rem;
      border: none;
      color: ${colors.pColor};
      font-weight: 700;
      border-radius: 14px;
    }
  }
`

const SliderSlick = styled(Slider)`
  width: 100%;
  margin: 0 auto;
  @media ${device.lg} {
    transform: translateY(-30px);
  }
  .slick-track {
    min-height: 450px;
    width: 100%;
    overflow: hidden;
  }
  .slick-slide {
    overflow: hidden;
    & .item-slick {
      height: 350px;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      ${anims.transition};
      cursor: pointer;
      @media (max-width: 768px) {
        height: 180px;
      }
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0.7;
        z-index: 1;
      }
      & .play-trailer-modal {
        width: 80px;
        height: 80px;
        border: 1px solid white;
        background: url(${playIcon});
        background-size: 50%;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        border-radius: 50%;
        left: 50%;
        right: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(1);
        transform-origin: center;
        ${anims.transition};
        z-index: 11;
        &:hover {
          transform: translate(-50%, -50%) scale(1.2);
          transform-origin: center;
        }
        @media (max-width: 768px) {
          width: 60px;
          height: 60px;
        }
      }
      & .back {
        width: 100%;
        transform: scale(1);
        ${anims.transition};
      }
      & .text {
        position: absolute;
        bottom: 0%;
        left: 0%;
        text-align: center;
        color: white;
        z-index: 11;
        font-size: 1em;
        font-weight: 700;
        width: 100%;
        opacity: 1;
        ${anims.transition};
        display: flex;
        align-items: center;
        padding: 1em 2em;
        @media (max-width: 768px) {
          padding: 1em 1em;
        }
        & .avatar {
          overflow: hidden;
          border-radius: 50%;
          width: 60px;
          margin-right: 10px;
          @media (max-width: 768px) {
            width: 40px;
          }
        }
        & .data-user {
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          & span {
            color: white;
            font-weight: 700;
            font-size: 0.8em;
            display: block;
            margin: 0.2em 0;
          }
        }
      }
    }
  }
  .slick-slide-active {
  }

  .slick-center {
    & .item-slick {
      height: 380px;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      ${anims.transition};
      border-bottom-right-radius: 20px;
      border-bottom-left-radius: 20px;
      @media (max-width: 768px) {
        height: 220px;
      }
      & .text {
        opacity: 1;
        & span {
          color: ${colors.sColor};
        }
      }
      & .back {
        width: 100%;
        transform: scale(1.3);
      }
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${colors.pColor};
        opacity: 0.7;
        z-index: 1;
      }
    }
  }
`

const NextArrow = styled.div`
  background: url(${ArrowNextIcon}) no-repeat center / contain;
  top: 50% !important;
  right: 10px;
  z-index: 1000;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  overflow: hidden;
  transition: 0.5s ease-in;
  @media (max-width: 768px) {
    right: 0;
    top: 65% !important;
    background: url(${ArrowNextIcon}) no-repeat center / contain;
  }
  &:hover {
    background: ${colors.sColor} url(${ArrowNextIcon}) no-repeat center /
      contain;
  }
  &::before {
    display: none;
  }
`

const PrevArrow = styled.div`
  background: url(${ArrowPrevIcon}) no-repeat center / contain;
  left: inherit;
  top: 50% !important;
  left: 10px;
  z-index: 1000;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  overflow: hidden;
  transition: 0.5s ease-in;
  @media (max-width: 768px) {
    top: 65% !important;
    left: 50%;
    background: url(${ArrowPrevIcon}) no-repeat center / contain;
  }
  &:hover {
    background: ${colors.sColor} url(${ArrowPrevIcon}) no-repeat center /
      contain;
  }
  &::before {
    display: none;
  }
`

const ModalStyle = styled(Modal)`
  & .modal-content {
    background: transparent;
    border: none;
  }
  & .close {
    position: absolute;
    right: 40px;
    top: 40px;
    z-index: 100;
    width: 20px;
    height: 20px;
    background: url(${Close});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
`

const Results = () => {
  const settings = {
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 3,
    speed: 500,
    dots: false,
    arrows: true,
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  }
  //Modal Results
  const [selectedResult, setSelectedResult] = useState("")
  const [openTrailer, setOpenTrailer] = useState(null)
  const handleTrailer = result => {
    console.log(result)
    setSelectedResult(result.trailer)
    setOpenTrailer(true)
  }
  const handleCloseModal = e => {
    if (modalContent.current && !modalContent.current.contains(e.target)) {
      setOpenTrailer(false)
    }
  }
  const closeModal = e => {
    setOpenTrailer(false)
  }

  //Modal Form
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  let modalContent = useRef(null)

  const results = [
    {
      id: 0,
      img:
        "https://libelstudios.com/wp-content/uploads/2020/02/RESULTADO-DE-ALUMNOS-LIBEL-ACADEMY-266x300.jpeg",
      name: "Juan Vega",
      trailer: "https://www.youtube.com/embed/GhstmbOtSuI",
      avatar:
        "https://libelstudios.com/wp-content/uploads/elementor/thumbs/JUAN-VEGA-RESULTADO-ALUMNOS-LIBEL-ACADEMY-ollpv954x87rie8jjmnb3itvweqzowxfbphjrkb85g.jpeg",
      from: "Colombia",
    },
    {
      id: 1,
      img:
        "https://libelstudios.com/wp-content/uploads/2020/03/RESULTADOS-JORGE-LUIS-TANQUE-CURSO-LIBEL-ACADEMY.jpeg",
      name: "Jorge Luis​",
      trailer: "https://www.youtube.com/embed/jJf9lpZfd_M",
      avatar:
        "https://libelstudios.com/wp-content/uploads/elementor/thumbs/ALUMNO-JORGE-LUIS-MEXICO-olzupbo5149tlq7uvprkz0sb9zb9zqeb5qjy27xcsk.jpg",
      from: "México",
    },
    {
      id: 3,
      img:
        "https://libelstudios.com/wp-content/uploads/2020/03/RESULTADO-GABRIEL-PASCUAL-CURSO-ONLINE-BLENDER-LIBEL-768x857.jpeg",
      name: "Gabriel Pascual",
      trailer: "https://www.youtube.com/embed/VFdTJ1Fq1TU",
      avatar:
        "https://libelstudios.com/wp-content/uploads/elementor/thumbs/Gabriel-Pascual-ollpuu3pvvn6cmudzg59zmmie8t49r9pxn1s34xix0.jpeg",
      from: "España / Sanabria",
    },
    {
      id: 4,
      img:
        "https://libelstudios.com/wp-content/uploads/2020/02/RESULTADO-JOSE-DAVID-RAMIREZ-VENEZUELA-768x857.jpeg",
      name: "José David Ramírez",
      trailer: "https://www.youtube.com/embed/KAoOxXoRuDw",
      avatar:
        "https://libelstudios.com/wp-content/uploads/elementor/thumbs/ALUMNO-JOSE-DAVID-RAMIREZ-ollpzfjbapxn40635fnm6gvmy25pwhih8dv8ju48hw.jpeg",
      from: "Venezuela",
    },
    {
      id: 5,
      img:
        "https://libelstudios.com/wp-content/uploads/2020/02/RESULTADO-DE-ALUMNOS-LIBEL-ACADEMY-266x300.jpeg",
      name: "Juan Vega",
      trailer: "https://www.youtube.com/embed/GhstmbOtSuI",
      avatar:
        "https://libelstudios.com/wp-content/uploads/elementor/thumbs/JUAN-VEGA-RESULTADO-ALUMNOS-LIBEL-ACADEMY-ollpv954x87rie8jjmnb3itvweqzowxfbphjrkb85g.jpeg",
      from: "Colombia",
    },
    {
      id: 6,
      img:
        "https://libelstudios.com/wp-content/uploads/2020/03/RESULTADOS-JORGE-LUIS-TANQUE-CURSO-LIBEL-ACADEMY.jpeg",
      name: "Jorge Luis​",
      trailer: "https://www.youtube.com/embed/jJf9lpZfd_M",
      avatar:
        "https://libelstudios.com/wp-content/uploads/elementor/thumbs/ALUMNO-JORGE-LUIS-MEXICO-olzupbo5149tlq7uvprkz0sb9zb9zqeb5qjy27xcsk.jpg",
      from: "México",
    },
    {
      id: 7,
      img:
        "https://libelstudios.com/wp-content/uploads/2020/03/RESULTADO-GABRIEL-PASCUAL-CURSO-ONLINE-BLENDER-LIBEL-768x857.jpeg",
      name: "Gabriel Pascual",
      trailer: "https://www.youtube.com/embed/VFdTJ1Fq1TU",
      avatar:
        "https://libelstudios.com/wp-content/uploads/elementor/thumbs/Gabriel-Pascual-ollpuu3pvvn6cmudzg59zmmie8t49r9pxn1s34xix0.jpeg",
      from: "España / Sanabria",
    },
    {
      id: 8,
      img:
        "https://libelstudios.com/wp-content/uploads/2020/02/RESULTADO-JOSE-DAVID-RAMIREZ-VENEZUELA-768x857.jpeg",
      name: "José David Ramírez",
      trailer: "https://www.youtube.com/embed/KAoOxXoRuDw",
      avatar:
        "https://libelstudios.com/wp-content/uploads/elementor/thumbs/ALUMNO-JOSE-DAVID-RAMIREZ-ollpzfjbapxn40635fnm6gvmy25pwhih8dv8ju48hw.jpeg",
      from: "Venezuela",
    },
  ]

  return (
    <ResultsSection>
      <div className="call-to-action">
        <Container fluid={true}>
          <Row noGutters={true} className="justify-content-center">
            <Col lg={4} className="text-center">
              <h3>
                Resultados de nuestros <br /> estudiantes
              </h3>
              <p className="text-results">Los mejores proyectos</p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container fluid={true}>
        <Row className="p-0">
          <Col lg={12}>
            <SliderSlick {...settings}>
              {results.length > 0
                ? results.map(result => (
                    <div className="item-slick" key={result.id}>
                      <button
                        onClick={e => handleTrailer(result)}
                        className="play-trailer-modal"
                      ></button>
                      <h5 className="text">
                        <img
                          src={result.avatar}
                          alt={result.name}
                          className="avatar"
                        />
                        <div className="data-user">
                          <span>{result.name}</span>
                          <span>{result.from}</span>
                        </div>
                      </h5>
                      <img
                        src={result.img}
                        alt={result.name}
                        className="back"
                      />
                    </div>
                  ))
                : "No hay projectos"}
            </SliderSlick>
          </Col>
        </Row>
      </Container>
      <ModalResult
        modalState={openTrailer}
        closeTrailer={handleCloseModal}
        closeModal={closeModal}
        forwardRef={modalContent}
        result={selectedResult}
      />
    </ResultsSection>
  )
}

export default Results
